import {TitleOptions, XAxisLabelsOptions, XAxisOptions, YAxisLabelsOptions, YAxisOptions} from 'highcharts';
import {BrandDarkBlue} from '../theme';

export const YAxisLabelStyles: YAxisLabelsOptions = {
	style: {
		fontStyle: 'normal',
		fontWeight: '400',
		fontSize: '12px',
		color: '#FFFFFF',
		opacity: 0.7,
		padding: '0px',
	},
};

export const XAxisLabelStyles: XAxisLabelsOptions = {
	style: {
		fontStyle: 'normal',
		fontWeight: '400',
		fontSize: '12px',
		color: '#FFFFFF',
		opacity: 0.7,
		padding: '0px',
	},
};

export const ChartTitleProps: TitleOptions = {
	align: 'left',
	margin: 20,
	style: {
		fontFamily: 'DM Sans',
		fontWeight: '400',
		color: '#FFFFFF',
		fontSize: '18px',
		marginBottom: '12px',
	},
};

export const YAxisProps: YAxisOptions = {
	gridLineWidth: 0.5,
	gridLineColor: '#5f3492',
	lineColor: '#5f3492',
	lineWidth: 0.5,
};

export const XAxisProps: XAxisOptions = {
	type: 'datetime',
	gridLineWidth: 0.5,
	gridLineColor: '#5f3492',
	lineColor: '#5f3492',
	lineWidth: 0.5,
	tickColor: BrandDarkBlue,
	maxPadding: 0,
	dateTimeLabelFormats: {
		day: '%e %b',
	},
};
